import React from 'react'
import {Button, Model} from 'helpers'

type Props = {
 containerClass?: string
 titleClass?: string
 title?: string
 subTitle?: string
 msg?: React.ReactNode
 showConfirmModel: boolean
 yesBtnClass?: string
 noBtnClass?: string
 yesBtnText?: string
 noBtnText?: string
 handleConfirmBtnClick: (show: boolean) => void
}

const KTConfirmPopup: React.FC<Props> = (props: Props) => {
 return (
  <>
   <Model
    show={props.showConfirmModel}
    showHeader={false}
    closeBtnClass='absolute right-4 top-2 !bg-[#E6EBF0] !rounded-3xl w-7 h-7 !text-[#33393D]'
    header={''}
    close={() => {
     void props.handleConfirmBtnClick(false)
    }}
    modelClass='md:w-[600px]'
    modelContainerClass={`${props?.containerClass} !rounded-2xl`}
    modelBodyClass='p-10'
   >
    <div className='w-full'>
     <div className='w-full'>
      <p
       className={`${props?.titleClass} text-[#171B1F] text-left font-bold text-2xl`}
      >
       {props.title}
      </p>
      <div className='text-[#33393D] text-left my-7'>
       <p className='font-medium text-xl'>
        {props?.subTitle}
       </p>
       {props?.msg && <div>{props.msg}</div>}
      </div>
      <div className='grid md:grid-cols-2 gap-5 w-full'>
       <Button
        type='button'
        disabled={false}
        onClick={() => {
         void props.handleConfirmBtnClick(false)
        }}
        color='red'
        className={`${props?.yesBtnClass} text-center py-[9px] px-6 bg-[#CC293F] 
                  !rounded-lg text-base text-white font-semibold border-[#CC293F]`}
       >
        {props.noBtnText}
       </Button>
       <Button
        type='button'
        disabled={false}
        onClick={() => {
         void props.handleConfirmBtnClick(true)
        }}
        color='green'
        className={`${props?.noBtnClass} text-center py-[9px] px-6 bg-[#0E7A41] 
                  !rounded-lg text-base text-white font-semibold border-[#0E7A41]`}
       >
        {props.yesBtnText}
       </Button>
      </div>
     </div>
    </div>
   </Model>
  </>
 )
}

export {KTConfirmPopup}
